<template>
  <div class="main-content-wrap sidenav-open d-flex flex-column pb-4">
    <div class="main-header pl-4 mt-3" style="z-index: 60;">
      <div class="row">
        <div
          style="align-self: center;"
          class="logo col-md-1 col-lg-1 col-12 py-0"
        >
          <div
            class="dropdown animate__animated animate__fadeIn"
            style="font-size: 120%;"
          >
            <i
              @click="hasHistory() ? $router.go(-1) : $router.push('/')"
              style="cursor: pointer; position: relative; top: 2px; color: #069;"
              class="fal fa-arrow-alt-circle-left mr-1"
            ></i>
            <span class="ml-2" style="top: 4%; position: relative;">Back</span>
          </div>
        </div>
      </div>
      <div style="margin: auto"></div>
    </div>

    <div
      class="main-content"
      :class="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
          ? 'px-2'
          : null
      "
    >
      <div
        class="breadcrumb d-flex justify-content-between align-items-center"
        style="margin-top: 1rem;"
      >
        <h1>
          <span class="col-4">Completed Candidates</span>
        </h1>
      </div>

      <div class="card w-100" style="border-radius: 10px;">
        <div class="card-body px-1 py-1 pt-0 pr-0">
          <div class="px-3 pt-2">
            <div
              class="d-flex justify-content-between align-items-center"
              style="min-height: 48px; padding: 6px 0; flex-wrap: wrap;"
            >
              <div>
                <strong>Completed Interview Candidates</strong>
                <v-btn
                  v-if="selectedCandidateIds.length > 0"
                  small
                  color="#28a745"
                  class="text-white ml-3"
                  @click="trigger_onboarding"
                  :loading="triggerOnboardingLoading"
                >
                  {{ triggerOnboardingTxt }} ({{ selectedCandidateIds.length }})
                </v-btn>
              </div>
              <div class="d-flex align-items-center">
                <v-text-field
                  v-model="search"
                  dense
                  solo
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Search"
                  style="max-width: 240px;"
                />
              </div>
            </div>
          </div>

          <div
            class="table-responsive"
            style="border-radius: 10px; height: 600px; overflow-y: auto;"
          >
            <table class="table candidate-table">
              <thead>
                <tr>
                  <th class="select-all-th" style="border-top: none;">
                    <label class="checkbox checkbox-secondary mb-0">
                      <input
                        type="checkbox"
                        :checked="
                          filteredCandidates.length &&
                          selectedCandidateIds.length === filteredCandidates.length
                        "
                        @change="toggleSelectAll"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </th>
                  <th class="text-left" style="border-top: none;">Name</th>
                  <th class="text-left" style="border-top: none;">Email</th>
                  <th class="text-left" style="border-top: none;">Phone</th>
                  <th class="text-left" style="border-top: none;">Interview Date</th>
                  <th class="text-left" style="border-top: none;">Status</th>
                  <th class="text-center" style="border-top: none;">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="candidate in filteredCandidates"
                  :key="candidate.id"
                >
                  <th>
                    <label class="checkbox checkbox-secondary">
                      <input
                        type="checkbox"
                        :checked="selectedCandidateIds.indexOf(candidate.id) !== -1"
                        @change="toggleCandidateSelection(candidate.id)"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </th>
                  <td class="text-left">
                    {{
                      candidate.name ||
                        `${candidate.firstname || candidate.employee_fristname || candidate.employee_firstname || candidate.first_name || ''} ${candidate.lastname || candidate.employee_lastname || candidate.last_name || ''}`.trim() ||
                        `#${candidate.id}`
                    }}
                  </td>
                  <td class="text-left">
                    {{ candidate.email || candidate.employee_email || '-' }}
                  </td>
                  <td class="text-left">
                    {{ candidate.phone || candidate.employee_phone1 || '-' }}
                  </td>
                  <td class="text-left">
                    {{ formatDate(candidate.interview_date) }}
                  </td>
                  <td class="text-left text-capitalize">
                    {{ candidate.status || 'completed' }}
                  </td>
                  <td class="text-center">
                    <v-btn
                      small
                      color="#069"
                      class="text-white"
                      @click="openSingleCandidateOfferLetter(candidate)"
                    >
                      <i class="fal fa-file-pdf mr-1"></i>Upload Offer Letter
                    </v-btn>
                  </td>
                </tr>
                <tr v-if="!loading && filteredCandidates.length === 0">
                  <td colspan="7" class="text-center">
                    No completed candidates found
                  </td>
                </tr>
                <tr v-if="loading">
                  <td colspan="7" class="text-center">
                    <v-progress-circular
                      indeterminate
                      color="#069"
                      size="20"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Single Candidate Offer Letter Upload Dialog -->
    <v-dialog v-model="singleOfferLetterDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title
          style="background: linear-gradient(45deg, #28a745, #20c997); color: white; border-radius: 15px 15px 0 0;"
        >
          <span class="headline">
            <i class="fal fa-file-pdf mr-2"></i>Upload Offer Letter
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-if="currentCandidateForOfferLetter">
              <div class="mb-4">
                <p><strong>Candidate:</strong> {{ getCandidateName(currentCandidateForOfferLetter) }}</p>
                <p><strong>Email:</strong> {{ currentCandidateForOfferLetter.email || currentCandidateForOfferLetter.employee_email || '-' }}</p>
              </div>
              <v-file-input
                v-model="singleOfferLetterFile"
                label="Select offer letter"
                accept=".pdf,.doc,.docx"
                prepend-inner-icon="mdi-file-pdf-box"
                solo
                dense
                color="#069"
              ></v-file-input>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            @click="closeSingleOfferLetterDialog"
            :disabled="uploadingSingleOfferLetter"
          >
            Cancel
          </v-btn>
          <v-btn
            color="grey"
            text
            @click="skipSingleOfferLetter"
            :disabled="uploadingSingleOfferLetter"
          >
            Skip
          </v-btn>
          <v-btn
            color="success"
            dark
            @click="uploadSingleOfferLetter"
            :loading="uploadingSingleOfferLetter"
            :disabled="uploadingSingleOfferLetter || !singleOfferLetterFile"
          >
            <i class="fal fa-upload mr-2"></i>
            {{ uploadingSingleOfferLetter ? 'Uploading...' : 'Upload' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '@/main';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      search: '',
      completedCandidates: [],
      selectedCandidateIds: [],
      singleOfferLetterDialog: false,
      currentCandidateForOfferLetter: null,
      singleOfferLetterFile: null,
      uploadingSingleOfferLetter: false,
      uploadedOfferLetters: {}, // Track which candidates have offer letters uploaded
      triggerOnboardingLoading: false,
      triggerOnboardingTxt: 'Trigger Onboarding',
    };
  },
  computed: {
    ...mapGetters(['authCompanyData', 'authCompanyCandidates', 'authCompanyEmployees']),
    filteredCandidates() {
      let list = this.completedCandidates;
      if (this.search) {
        const q = this.search.toLowerCase();
        list = list.filter(
          (c) =>
            (c.name || '').toLowerCase().includes(q) ||
            (c.email || c.employee_email || '').toLowerCase().includes(q) ||
            (c.phone || c.employee_phone1 || '').toLowerCase().includes(q)
        );
      }
      return list;
    },
    selectedCandidates() {
      return this.completedCandidates.filter((c) =>
        this.selectedCandidateIds.includes(c.id)
      );
    },
    ids_to_work_on() {
      return this.selectedCandidates.map((c) => ({ id: c.id }));
    },
  },
  methods: {
    ...mapActions(['fetch_candidates', 'fetch_company_employees']),
    hasHistory() {
      return window.history.length > 2;
    },
    toggleSelectAll() {
      const allSelected =
        this.filteredCandidates.length &&
        this.selectedCandidateIds.length === this.filteredCandidates.length;

      if (allSelected) {
        this.selectedCandidateIds = [];
      } else {
        this.selectedCandidateIds = this.filteredCandidates.map((c) => c.id);
      }
    },
    toggleCandidateSelection(candidateId) {
      const idx = this.selectedCandidateIds.indexOf(candidateId);
      if (idx === -1) {
        this.selectedCandidateIds.push(candidateId);
      } else {
        this.selectedCandidateIds.splice(idx, 1);
      }
    },
    formatDate(dateStr) {
      if (!dateStr) {
        return 'Not scheduled';
      }
      const dateString = String(dateStr).trim();
      if (
        dateString === '0000-00-00' ||
        dateString === 'null' ||
        dateString === 'undefined' ||
        dateString === '' ||
        dateString === 'Invalid Date'
      ) {
        return 'Not scheduled';
      }
      try {
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
          const [year, month, day] = dateString.split('-');
          if (year === '0000' || month === '00' || day === '00') {
            return 'Not scheduled';
          }
          return `${month}/${day}/${year}`;
        }
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          if (/^\d{4}-\d{2}-\d{2}/.test(dateString)) {
            return dateString;
          }
          return 'Not scheduled';
        }
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
      } catch (e) {
        if (/^\d{4}-\d{2}-\d{2}/.test(dateString)) {
          return dateString;
        }
        return 'Not scheduled';
      }
    },
    async fetchCompletedCandidates() {
      this.loading = true;
      try {
        const token = localStorage.getItem('userToken');
        // Fetch all interviews
        const { data } = await axios.get(`${BASE_URL}interviews`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        let interviews = Array.isArray(data?.data) ? data.data : data || [];

        // Get all candidates with completed status
        const completedCandidatesMap = new Map();
        
        for (const interview of interviews) {
          // Fetch full interview details to get candidates
          try {
            const { data: interviewData } = await axios.get(
              `${BASE_URL}interviews/${interview.id}`,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
            const fullInterview = interviewData?.data || interviewData || interview;
            const candidates = fullInterview.candidates || [];
            
            candidates.forEach((c) => {
              if (c.status === 'completed' && c.candidate_id) {
                // Find the actual candidate from the candidates list
                const actualCandidate = this.authCompanyCandidates?.find(
                  (cc) => cc.id === c.candidate_id || cc.id == c.candidate_id
                );
                if (actualCandidate && !completedCandidatesMap.has(actualCandidate.id)) {
                  completedCandidatesMap.set(actualCandidate.id, {
                    ...actualCandidate,
                    interview_date: interview.interview_date || fullInterview.interview_date,
                    status: c.status,
                  });
                }
              }
            });
          } catch (e) {
            console.error('Error fetching interview details:', e);
          }
        }

        this.completedCandidates = Array.from(completedCandidatesMap.values());
      } catch (e) {
        console.error('Error fetching completed candidates:', e);
      } finally {
        this.loading = false;
      }
    },
    openSingleCandidateOfferLetter(candidate) {
      this.currentCandidateForOfferLetter = candidate;
      this.singleOfferLetterFile = null;
      this.singleOfferLetterDialog = true;
    },
    closeSingleOfferLetterDialog() {
      this.singleOfferLetterDialog = false;
      this.currentCandidateForOfferLetter = null;
      this.singleOfferLetterFile = null;
    },
    skipSingleOfferLetter() {
      this.closeSingleOfferLetterDialog();
    },
    async uploadSingleOfferLetter() {
      if (!this.singleOfferLetterFile || !this.currentCandidateForOfferLetter) {
        return;
      }

      this.uploadingSingleOfferLetter = true;

      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer);
          toast.addEventListener('mouseleave', this.$swal.resumeTimer);
        },
      });

      try {
        const candidate = this.currentCandidateForOfferLetter;
        const candidateEmail = candidate.email || candidate.employee_email;
        
        // Check if candidate has already been converted to an employee
        await this.fetch_company_employees();
        const employee = this.authCompanyEmployees?.find(
          (emp) => emp.employee_email === candidateEmail
        );

        if (employee) {
          // Candidate is already an employee, upload immediately
          const formData = new FormData();
          formData.append('id', employee.id);
          formData.append('company_id', this.authCompanyData?.id);
          formData.append('file', this.singleOfferLetterFile);

          await axios.post(`${BASE_URL}uploadofferletter`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            },
          });

          Toast.fire({
            icon: 'success',
            title: 'Offer letter uploaded successfully',
          });

          this.closeSingleOfferLetterDialog();
        } else {
          // Candidate is not yet an employee - we need employee ID to upload
          // Store the file to upload after onboarding is triggered
          const candidateId = candidate.id;
          
          this.uploadedOfferLetters[candidateId] = {
            candidateId: candidateId,
            candidateEmail: candidateEmail,
            file: this.singleOfferLetterFile,
          };

          Toast.fire({
            icon: 'info',
            title: 'Offer letter saved. It will be uploaded automatically after you trigger onboarding for this candidate.',
          });

          this.closeSingleOfferLetterDialog();
        }
      } catch (error) {
        const errorMsg =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Failed to upload offer letter';
        Toast.fire({
          icon: 'error',
          title: errorMsg,
        });
        console.error('Error uploading offer letter:', error);
      } finally {
        this.uploadingSingleOfferLetter = false;
      }
    },
    getCandidateName(candidate) {
      return (
        candidate.name ||
        `${candidate.firstname || candidate.employee_fristname || candidate.employee_firstname || candidate.first_name || ''} ${candidate.lastname || candidate.employee_lastname || candidate.last_name || ''}`.trim() ||
        `#${candidate.id}`
      );
    },
    async mapCandidatesToEmployees() {
      const candidateToEmployeeMap = {};
      await this.fetch_company_employees();
      
      // Get offer letters from uploadedOfferLetters object
      const offerLettersArray = Object.values(this.uploadedOfferLetters);
      
      offerLettersArray.forEach((item) => {
        const employee = this.authCompanyEmployees?.find(
          (emp) => emp.employee_email === item.candidateEmail
        );
        if (employee) {
          candidateToEmployeeMap[item.candidateId] = employee.id;
        }
      });
      return candidateToEmployeeMap;
    },
    async uploadPendingOfferLetters(candidateToEmployeeMap) {
      const offerLettersArray = Object.values(this.uploadedOfferLetters);
      
      if (offerLettersArray.length === 0) {
        return;
      }

      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer);
          toast.addEventListener('mouseleave', this.$swal.resumeTimer);
        },
      });

      const uploadPromises = offerLettersArray.map(async (item) => {
        const employeeId = candidateToEmployeeMap[item.candidateId];
        if (!employeeId) {
          console.warn(
            `No employee ID found for candidate ${item.candidateId}`
          );
          return { success: false, candidateId: item.candidateId };
        }

        const formData = new FormData();
        formData.append('id', employeeId);
        formData.append('company_id', this.authCompanyData?.id);
        formData.append('file', item.file);

        try {
          await axios.post(`${BASE_URL}uploadofferletter`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            },
          });
          return { success: true, candidateId: item.candidateId };
        } catch (error) {
          console.error(
            `Error uploading offer letter for candidate ${item.candidateId}:`,
            error
          );
          return { success: false, candidateId: item.candidateId, error };
        }
      });

      const results = await Promise.all(uploadPromises);
      const successful = results.filter((r) => r.success).length;
      const failed = results.filter((r) => !r.success).length;

      if (successful > 0 && failed === 0) {
        Toast.fire({
          icon: 'success',
          title: `All offer letters uploaded successfully`,
        });
      } else if (successful > 0 && failed > 0) {
        Toast.fire({
          icon: 'warning',
          title: `${successful} uploaded, ${failed} failed`,
        });
      } else if (failed > 0) {
        Toast.fire({
          icon: 'error',
          title: 'Failed to upload offer letters',
        });
      }

      // Clear uploaded offer letters after successful upload
      this.uploadedOfferLetters = {};
    },
    async trigger_onboarding() {
      const _this = this;
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      if (this.selectedCandidateIds.length === 0) {
        Toast.fire({
          icon: 'error',
          title: 'Please select at least one candidate',
        });
        return;
      }

      _this.triggerOnboardingTxt = '';
      _this.triggerOnboardingLoading = true;

      const ids = _this.ids_to_work_on.map((item) => ({ id: item.id }));

      try {
        await axios.post(
          `${BASE_URL}triggeronboarding`,
          {
            comment: 'Congratulations! Welcome to our company',
            ids: ids,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('userToken')}`,
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          }
        );

        Toast.fire({
          icon: 'success',
          title: 'Onboarding process triggered successfully',
        });

        // Upload offer letters if any were prepared
        const offerLettersArray = Object.values(_this.uploadedOfferLetters);
        if (offerLettersArray.length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          const candidateToEmployeeMap = await _this.mapCandidatesToEmployees();
          await _this.uploadPendingOfferLetters(candidateToEmployeeMap);
        }

        await _this.fetch_candidates();
        await _this.fetch_company_employees();
        await _this.fetchCompletedCandidates();
        this.selectedCandidateIds = [];
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Failed to trigger onboarding process';
        Toast.fire({
          icon: 'error',
          title: msg,
        });
        console.log(error.response || error);
      } finally {
        _this.triggerOnboardingLoading = false;
        _this.triggerOnboardingTxt = 'Trigger Onboarding';
      }
    },
  },
  mounted() {
    document.title = 'Kylian ERP - Completed Candidates';
    this.fetchCompletedCandidates();
  },
};
</script>

<style scoped>
.candidate-table thead th {
  background: #0b5cab;
  color: #fff;
}
.candidate-table th,
.candidate-table td {
  vertical-align: middle;
}
.candidate-table th:first-child,
.candidate-table td:first-child {
  width: 56px;
  text-align: left;
}
.select-all-th .checkbox {
  position: relative;
  top: -20px;
}
.candidate-table .checkbox {
  margin: 0;
}
.candidate-table .checkbox input {
  transform: scale(0.85);
}
.candidate-table .checkbox .checkmark {
  top: 0;
}
</style>

